var map = {
	"./be.json": 965,
	"./bg.json": 371,
	"./cs.json": 473,
	"./de.json": 997,
	"./el.json": 879,
	"./en.json": 194,
	"./es.json": 299,
	"./et.json": 475,
	"./fr.json": 376,
	"./he.json": 155,
	"./hu.json": 68,
	"./is.json": 374,
	"./it.json": 130,
	"./jp.json": 733,
	"./ko.json": 873,
	"./nl.json": 351,
	"./nn.json": 697,
	"./no.json": 161,
	"./pl.json": 314,
	"./pt.json": 508,
	"./ru.json": 849,
	"./sk.json": 952,
	"./sr.json": 865,
	"./sv.json": 273,
	"./tr.json": 830,
	"./uk.json": 362,
	"./ur.json": 125,
	"./zh-cn.json": 814,
	"./zh-tw.json": 220
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 329;